import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { PropsWithChildren, ReactNode } from 'react';

interface EntityViewBlockProps {
    title: string | ReactNode;
    className?: string;
}

function EntityViewBlock({ children, title, className }: PropsWithChildren<EntityViewBlockProps>) {
    return (
        <Stack className={ className }>
            <Typography variant="body2"
                fontWeight="medium"
                color="text.primary"
                gutterBottom
            >
                { title }
            </Typography>
            <Stack gap={ 1 }
                color="text.tertiary"
            >
                { children }
            </Stack>
        </Stack>
    );
}

export default EntityViewBlock;
